var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"items-center"},[_c('p',{staticClass:"text-xl text-dark font-bold items-center"},[(_vm.icon)?_c('feather-icon',{attrs:{"icon":_vm.icon,"svgClasses":"h-3 w-3"}}):_vm._e(),_vm._v("\n  "+_vm._s(_vm.title))],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }